import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '比赛ID',
      prop: 'matchId'
    },
    {
      label: '比赛名称',
      prop: 'matchName'
    },
    {
      label: '主办方',
      prop: 'orgName'
    },
    {
      label: '比赛类型',
      prop: 'matchType'
    },
    {
      label: '签位',
      prop: 'signNo'
    },
    {
      label: '比赛时间',
      prop: 'matchStartTime'
    },
    {
      label: '裁判',
      prop: 'referee'
    },
    {
      label: '俱乐部',
      prop: 'clubName'
    },
    {
      label: '会长',
      prop: 'chairMan'
    },
    {
      label: '俱乐部积分',
      prop: 'clubScore'
    },
    {
      label: '会长账号',
      prop: 'chairmanId'
    },
    {
      label: '第六人',
      prop: 'isSixth'
    }
  ]
}
